export default __webpack_public_path__ + "static/media/mx_fm3_front.77497492.jpeg";